import { createThemedStyles } from "@/lib/functions/styles";
var stylesCreator = function (theme) {
    var _a, _b;
    return ({
        appBar: {
            position: "relative",
        },
        toolbar: theme.mixins.toolbar,
        layout: (_a = {
                marginTop: "5%",
                width: "auto",
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2)
            },
            _a[theme.breakpoints.up(600 + parseInt(theme.spacing(2)) * 2)] = {
                width: 600,
                marginLeft: "auto",
                marginRight: "auto",
            },
            _a),
        paper: (_b = {
                marginTop: theme.spacing(3),
                marginBottom: theme.spacing(3),
                padding: theme.spacing(2)
            },
            _b[theme.breakpoints.down("sm")] = {
                width: "100%",
                marginTop: 60,
            },
            _b[theme.breakpoints.up(600 + parseInt(theme.spacing(3)) * 2)] = {
                marginTop: theme.spacing(6),
                marginBottom: theme.spacing(6),
                padding: theme.spacing(3),
            },
            _b),
        stepper: {
            padding: theme.spacing(3, 0, 5),
        },
        buttons: {
            display: "flex",
            justifyContent: "flex-end",
        },
        button: {
            marginTop: theme.spacing(3),
            marginLeft: theme.spacing(1),
        },
        divider: {
            margin: "20px 0",
        },
        spinner: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
    });
};
export default createThemedStyles(stylesCreator);
